import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import Button from "../../components/Buttons/Button";
import Header from "../../components/Header";
import useWindowDimensions from "../../helpers/Hooks/useWindowDimensions";
import bankOfAmerica from "../../assets/bankLogos/bankOfAmerica.svg";
import capitalone from "../../assets/bankLogos/capitalone.svg";
import Charles from "../../assets/bankLogos/Charles.svg";
import chace from "../../assets/bankLogos/Chase.svg";
import citiBank from "../../assets/bankLogos/Citi.svg";
import usbank from "../../assets/bankLogos/usbank.svg";
import Alabama from "../../assets/bankLogos/Alabama.svg";
import { useNavigate } from "react-router-dom";
import { routes } from "../../helpers/Routes";
import NinjaLogoSVG from "../../assets/NinjaLogoSVG.svg";

const ConnectToYourbank = () => {
  const { height } = useWindowDimensions();
  const navigate = useNavigate();
  const [bank, setBank] = useState("");
  const [selectBank, setSelectBank] = useState(false);

  const [filterItem, setFilterItem] = useState([]);
  const [showData, setShowData] = useState(false);

  const propertiesJson = [
    {
      name: "Bank of America",
      imgUrl: bankOfAmerica,
    },
    {
      name: "Capital One",
      imgUrl: capitalone,
    },
    {
      name: "Charles Schwab",
      imgUrl: Charles,
    },
    {
      name: "Chase",
      imgUrl: chace,
    },
    {
      name: "Citibank",
      imgUrl: citiBank,
    },
    {
      name: "US Bank",
      imgUrl: usbank,
    },
    {
      name: "Alabama Central Credit Union",
      imgUrl: Alabama,
    },
  ];

  const onContinueClick_ConnectBank = () => {
    // if (selectBank === true)
    if (bank === "Alabama Central Credit Union") {
      navigate(routes.login);
    }
  };

  // Store filterData
  const filteredData =
    bank.length !== bank.length ? propertiesJson : filterItem;

  useEffect(() => {
    setFilterItem(
      propertiesJson.filter((item) =>
        item.name.toLowerCase().includes(bank.toLowerCase())
      )
    );
    bank.length !== 0 ? setShowData(true) : setShowData(false);
    // console.log(showData);
    console.log(bank.length > 0);
  }, [bank]);

  return (
    <>
      <Header />
      <main
        className="px-6 h-full flex flex-col"
        style={{ height: `${height - 75}px` }}
      >
        <div className="flex-grow">
          {/* Header */}
          <h1 className="text-xl font-bold  mb-[10px] text-center">
            Search for your
            <br />
            financial institution
          </h1>
          {/* detail content */}
          <p className=" mb-4 flex flex-col text-greySecondary text-sm text-center">
            <span>Select an institution below to</span>
            <span>authorize a secure connection</span>
          </p>

          {/* Search Bar */}
          <div className="inputTag my-2 py-4 px-[15px] flex items-center justify-items-center border border-border rounded-lg relative hover:border-primary">
            <div className="mr-[15px]">
              <FiSearch size={20} />
            </div>
            <div className="w-[100%]">
              <input
                type="text"
                placeholder="Search"
                className="w-[98%] outline-0 placeholder:text-sm placeholder:text-gray-400 outline-none"
                value={bank}
                onClick={(e) => {
                  setBank("Alabama Central Credit Union");
                }}
                onChange={(e) => {
                  setBank(e.target.value);
                  setSelectBank(false);
                }}
              />

              {/* {Object.keys(selectBank).length > 0 ? (
                <div className="flex items-center">
                  <div className="border px-1 py-[5px] rounded-full h-5 w-5 flex mr-2">
                    <img
                      src={selectBank.imgUrl}
                      className="items-center w-[100%]"
                      alt=""
                    />
                  </div>
                  <div className="font-medium">{selectBank.name}</div>
                </div>
              ) : (
                <input
                  type="text"
                  placeholder="Search"
                  className="w-[98%] outline-0 placeholder:text-sm placeholder:text-gray-400"
                  value={bank}
                  onChange={(e) => {
                    setBank(e.target.value);
                  }}
                />
              )} */}
            </div>
            <div
              onClick={(e) => {
                setBank("");
                setSelectBank(false);
              }}
              className="text-gray-300"
              role={"button"}
            >
              {bank !== "" ? <MdCancel size={20} /> : ""}
            </div>
          </div>

          {/* Bank List */}
          <div
            className={`flex flex-col gap-[14px] overflow-hidden overflow-y-auto`}
            style={{ height: `${height - 340}px` }}
          >
            {filteredData.map((data, index) => {
              if (
                data.name !== "Alabama Central Credit Union" ||
                bank === "Alabama Central Credit Union"
              ) {
                return (
                  <div
                    className="flex items-center"
                    key={index}
                    onClick={(e) => {
                      setBank(data.name);
                      setSelectBank(true);
                    }}
                    role={"button"}
                  >
                    <div className="outline-none rounded-full h-10 w-10 flex mr-2 my-1">
                      <img
                        src={data.imgUrl}
                        className="items-center w-[100%]"
                        alt={data.name}
                      />
                    </div>
                    <div className="font-medium">{data.name}</div>
                  </div>
                );
              }
            })}
            {filteredData.length === 0 ? <div>No Bank Found</div> : null}
          </div>
        </div>

        {/* Countinue */}
        <section className="flex flex-col items-center justify-center">
          <Button
            name={"Continue"}
            route={""}
            // isDisabled={!selectBank ? false : true}
            isDisabled={bank === "Alabama Central Credit Union" ? true : false}
            onContinueClick_ConnectBank={onContinueClick_ConnectBank}
          />
          <section className="mt-2 flex items-center justify-center">
            <div className="mr-[5px] text-xs font-medium text-greySecondary">
              Powered by
            </div>
            <img className="w-20 h-3" src={NinjaLogoSVG} />
          </section>
        </section>
      </main>
    </>
  );
};

export default ConnectToYourbank;
